import { Component, computed, inject, effect } from '@angular/core';
import { CheckoutService } from '../../services/checkout.service';
import { PaywallService } from '../../services/paywall.service';
import { isQuantityChargePlan, seatCountLabel } from '../../helpers/quantity.helper';

@Component({
  selector: 'yon-pw-paywall-success',
  imports: [],
  templateUrl: './paywall-success.component.html',
  styleUrl: './paywall-success.component.scss'
})
export class PaywallSuccessComponent {
  checkoutService: CheckoutService = inject(CheckoutService);
  public paywallService: PaywallService = inject(PaywallService);
  /**
   * Plan and seats only, no price: the list price here excludes the VAT that Stripe charged, so it would not match
   * the amount the buyer just paid.
   */
  public confirmationLine = computed(() => {
    const plan = this.paywallService.selectedChargePlan();
    if (!plan || !isQuantityChargePlan(plan)) {
      return '';
    }

    return `${plan.name} plan for ${seatCountLabel(this.paywallService.quantityFor(plan))}.`;
  });

  constructor() {
    effect(() => {
      if(this.paywallService.settings()?.thankYouData?.useThankYouRedirect) {
        setTimeout(() => {
          location.href = this.paywallService.settings()?.thankYouData?.thankYouRedirectUrl || '';
        }, 5000);
      }
    });
  }

  ngOnInit(): void {
    if (localStorage.getItem('sessionId')) {
      this.checkoutService.startConnection().subscribe(() => {
        console.log('SignalR connection established');

        this.checkoutService.completePurchaseSubscription().subscribe((response: any) => {
          console.log('Purchase completed successfully:', response);
        });
      });
    }
  }

}
